import React, { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { ModelInputRenderer } from 'components/index.js'
import { getArgsExampleAction } from 'store/actions/models.action'
import { useDispatch, useSelector } from 'react-redux'

const AdjustSetting = ({
  selectedAI,
  undoSelectedAI,
  runDeployment,
  selectedModel,
  argsArray,
  setSelectedModel,
  updateArgValues,
  setSelectMediaModalVisible,
  uploadFile,
  removeImage,
  uploadFilesMask,
  setDefaultValues,
  addDraggedImageToModel,
}) => {
  const { t } = useTranslation('common')
  const { argsModelExamples } = useSelector((state) => state.models)
  const [selectedArgsExample, setSelectedArgsExample] = useState(null)

  const dispatch = useDispatch()
  const updatedArgs = selectedModel?.args_order ? selectedModel?.args_order : argsArray

  useEffect(() => {
    if (selectedModel) {
      setDefaultValues(selectedModel)
    }
    if (!argsModelExamples) dispatch(getArgsExampleAction())
  }, [])

  useEffect(() => {
    if (argsModelExamples && !selectedArgsExample && selectedModel) {
      const argsModel = argsModelExamples?.filter((item) => item.model_id === selectedModel.id)
      setSelectedArgsExample(argsModel)
    }
  }, [argsModelExamples, selectedModel])

  return (
    <div className="setting-container rounded-lg h-[34dvh] md:h-[80vh]  pb-6 flex flex-col gap-4 relative mb-[-50px] md:mb-[-9vh]">
      <div>
        <div className="flex items-center gap-[80px] my-[12px] relative justify-center">
          <div
            className="flex gap-[4px] cursor-pointer absolute left-0"
            onClick={() => {
              undoSelectedAI(null)
            }}
          >
            <img src={'/assets/common/left-arr.svg'} alt="arrow" />
            <div className=" text-[14px]">{t('common.back')}</div>
          </div>
          <div className="font-bold !text-[14px]">{selectedAI.name}</div>
        </div>
      </div>
      {updatedArgs?.map((item, i) => {
        item = item?.replace(/^"+|"+$/g, '')
        return (
          <div
            key={`sac-${i}`}
            className="mb-1 px-2 py-1 rounded-xl border border-solid border-[#000000] border-opacity-10"
            style={{ boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.1)' }}
          >
            <div className="text-sm font-bold flex items-center min-h-[35px] justify-between">
              {t('common.step')} {i + 1}
              {selectedModel.args[item]?.type === 'image_list' && item?.includes('Model_images') ? (
                <button className="mb-2.5 md:mb-0 rounded-none md:rounded leading-3 font-bold cursor-pointer whitespace-nowrap bg-transparent border border-solid border-[#00000033] py-1.5 px-2 text-[#1a1725] text-[10px] h-[40px]">
                  {t('common.model-guidelines')}
                </button>
              ) : item?.includes('Clothing_images') ? (
                <button className="mb-2.5 md:mb-0 rounded-none md:rounded leading-3 font-bold cursor-pointer whitespace-nowrap bg-transparent border border-solid border-[#00000033] py-1.5 px-2 text-[#1a1725] text-[10px] h-[40px]">
                  {t('common.clothing-guidelines')}
                </button>
              ) : (
                ''
              )}
              {selectedModel.args[item]?.optional === true ? ' (optional)' : ''}
            </div>
            <p className="text-sm mt-2.5 text-wrap">{selectedModel.args[item]?.description}</p>
            <ModelInputRenderer
              itemKey={item}
              label={item}
              selectedModel={selectedModel}
              setSelectedModel={setSelectedModel}
              name={selectedModel.args[item]?.name}
              value={selectedModel.args[item]?.value}
              type={selectedModel.args[item]?.type}
              fileType={selectedModel.args[item]?.file_type}
              min={selectedModel.args[item]?.min}
              max={selectedModel.args[item]?.max}
              options={selectedModel.args[item]?.option_choices}
              onChange={(value) => updateArgValues(item, value)}
              selectImage={(selectedKey) => setSelectMediaModalVisible(selectedKey)}
              uploadFile={uploadFile}
              removeImage={removeImage}
              maskValue={
                selectedModel?.args[item]?.value
                  ? selectedModel?.args[item]?.value
                  : selectedModel?.args[updatedArgs[0]]?.value
              }
              selectedArgsExample={selectedArgsExample?.filter((el) => el.arg_name === item)}
              updateArgValues={updateArgValues}
              uploadFilesMask={uploadFilesMask}
              addDraggedImageToModel={addDraggedImageToModel}
              isSmall
            />
          </div>
        )
      })}
      <div className="gap-4 !hidden mt-[20px] ml-0 justify-center">
        <div
          className={` w-full 
        h-10 md:h-12 
        bg-gradient-to-r from-blue-400 to-pink-500 
        text-white font-medium 
        text-xs md:text-sm lg:text-base 
        px-4 py-2 md:px-6 md:py-3 
        hover:from-pink-500 hover:to-blue-400 
        transition duration-300 ease-in-out 
        relative overflow-hidden `}
          onClick={() => runDeployment()}
        >
          {t('common.generate')}
        </div>
      </div>
    </div>
  )
}

export default AdjustSetting
